export const videoControls = {
  // Tab names
  configuration: 'Configurações',
  style: 'Personalização',
  preview: 'Preview',
  advanced: 'Avançado',
  
  // Configuration section
  mainControls: 'Controles Principais',
  additionalControls: 'Controles Adicionais',
  playbackControls: 'Controles de Reprodução',
  appearance: 'Aparência dos Controles',
  
  // Control labels
  showControls: 'Mostrar controles',
  disableControls: 'Desabilitar controles',
  showProgressBar: 'Mostrar barra de progresso',
  skipForward: 'Avançar 10s',
  rewind: 'Retroceder 10s',
  volumeControl: 'Controle de volume',
  showCurrentTime: 'Tempo atual',
  fullScreen: 'Tela cheia',
  smallPlayButton: 'Botão play pequeno',
  
  // Tooltips
  showControlsTooltip: 'Exibe ou oculta os controles do player (play, pause, volume, etc.)',
  disableControlsTooltip: 'Remove completamente a interação com os controles do player',
  showProgressBarTooltip: 'Exibe a barra de progresso na parte inferior do player',
  skipForwardTooltip: 'Adiciona botão para avançar 10 segundos no vídeo',
  rewindTooltip: 'Adiciona botão para retroceder 10 segundos no vídeo',
  volumeControlTooltip: 'Exibe controle deslizante de volume no player',
  showCurrentTimeTooltip: 'Mostra o tempo atual e duração do vídeo',
  fullScreenTooltip: 'Permite expandir o vídeo para tela cheia',
  smallPlayButtonTooltip: 'Usa uma versão menor do botão de play no centro do player',
  
  // Style section
  playerColors: 'Cores do Player',
  primaryColor: 'Cor Primária',
  primaryColorDescription: 'Aplicada em barra de controle, play, volume e botões principais',
  secondaryColor: 'Cor Secundária', 
  secondaryColorDescription: 'Aplicada em ícones secundários e textos do player',
  playIcon: 'Ícone do Play',
  customIcon: 'Upload do Ícone Personalizado',
  
  // Preview section
  previewTitle: 'Preview em Tempo Real',
  previewDescription: 'Este preview mostra como seus controles aparecerão no player real. As cores e configurações são aplicadas instantaneamente.',
  playerPreview: 'Preview do Player',
  
  // Advanced section
  testVideos: 'Vídeos de Teste',
  addTestVideo: 'Adicionar vídeo por URL',
  availableVideos: 'Vídeos disponíveis',
  noTestVideos: 'Nenhum vídeo de teste adicionado',
  uploadVideo: 'Arraste um vídeo aqui ou clique para enviar',
  selectVideo: 'Selecionar Vídeo',
  advancedSettings: 'Configurações Avançadas',
  videoId: 'ID do Vídeo',
  videoUrl: 'URL do Vídeo',
  videoTitle: 'Título do Vídeo',
  videoIdPlaceholder: 'ID único do vídeo',
  videoUrlPlaceholder: 'https://exemplo.com/video.mp4',
  videoTitlePlaceholder: 'Nome do vídeo',
};